import {DomainEvent} from './DomainEvent';
import {Match} from '../resources/Match';

export class MatchUpdated extends DomainEvent<Match> {}
